async function setCurrentUser(state, value) {
    Vue.set(state, 'currentUser', value);
    Vue.set(state, 'appIsReady', true);
}

async function updateCurrentUser(state, value) {
    state.currentUser = value;
}

function removeCurrentUser(state) {
    authUtils.removeToken();
    Vue.delete(state, 'currentUser');
    localStorage.removeItem('currentUser');
}

function setRejection(state, _err) {
    const err = _err && _err.response ? _err.response : _err;
    return Vue.set(state, 'rejection', err);
}

function setAppReady(state, value) {
    state.appIsReady = value;
}

function setCmsContent(state, value) {
    state.cmsContent = value;
}

function setPreFetchedUser(state, value) {
    state.preFetchedUser = value;
}

function setIsSeekingServicesProfile(state, value) {
    state.isSeekingServicesProfile = value;
}

function setLocation(state, value) {
    state.location = value;
}

function setPrice(state, value) {
    state.price = value;
}

function setServices(state, value) {
    state.services = value;
}

function setSettings(state, value) {
    state.settings = value;
}

function setFeatures(state, value) {
    state.features = value
}

function setCategory(state, value) {
    state.category = value
}

function setExtraContent(state, value) {
    state.extraContent = value
}

function setCategoryTemp(state, value) {
    state.categoryTemp = value
}

function setExtraContentTemp(state, value) {
    state.extraContentTemp = value
}

function setServicesTemp(state, value) {
    state.servicesTemp = value
}

function setFeaturesTemp(state, value) {
    state.featuresTemp = value
}

function setPriceTemp(state, value) {
    state.priceTemp = value;
}

function setSearchResponse(state, value) {
    state.searchResponse = value;
}

function refreshSearch(state, value) {
    state.refreshSearch = value;
}

function setSearchStories(state, value) {
    state.searchStories = value;
}

function setLoading(state, value) {
    state.loading = value;
}

function setFilterOpened(state, value) {
    state.filterOpened = value;
}

function setSearchDoneFromHome(state, value) {
    state.searchDoneFromHome = value;
}

function setAllServices(state, value) {
    state.allServices = value;
}

function setTopServices(state, value) {
    state.topServices = value;
}

function setHomeGirls(state, value) {
    state.homeGirls = value;
}

function setLocationTemp(state, value) {
    state.locationTemp = value;
}

function setSearchScrollPosition(state, value) {
    state.searchScrollPosition = value;
}

function setSearchRadius(state, value) {
    state.searchRadius = value;
}

function setSearchRadiusTemp(state, value) {
    state.searchRadiusTemp = value;
}

function setSimilarEscorts(state, value) {
    state.similarEscorts = value;
}

function setSavedSearchNewEscorts(state, value) {
    state.savedSearchNewEscorts = value;
}

function setSeoView(state, value) {
    state.seoView = value;
}

function setIs404View(state, value) {
    state.is404View = value;
}

function setTranslate(state, value) {
    state.translate = value;
}

function setRegionData(state, value) {
    state.regionData = value;
}

function setLocale(state, value) {
    state.locale = value;
}

function setSexySantaBannerIsVisible(state, value) {
    state.sexySantaBannerIsVisible = value;
}

function setIsManagerLoggedInAsEscort(state, value) {
    state.isManagerLoggedInAsEscort = value;
}

function setManagerAsEscortData(state, value) {
    state.managerAsEscortData = value;
}

function setFeatureOptions(state, value) {
    state.featureOptions = value;
}

function setVenue(state, value) {
    state.venue = value;
}

function setRanges(state, value) {
    state.ranges = value;
}

function setShouldReloadConversations(state, value) {
    state.shouldReloadConversations = value;
}

function setConversationUnreadMessageCount(state, value) {
    state.conversationUnreadMessageCount = value;
}

function setSelectedConversation(state, value) {
    state.selectedConversation = value;
}

function setUserProfileViewsNotificationCount(state, value) {
    return state.userProfileViewsNotificationCount = value;
}

function setSearchOnlyWithPrivateGallery(state, value) {
    const tmpContent = _.cloneDeep(state.extraContent);

    if (!!value) {
        tmpContent.privateGallery = true;
    } else {
        delete tmpContent.privateGallery;
    }

    /** need to set new object instead of changing one key value because otherwise vue is not reacting to change */
    state.extraContent = tmpContent;
}

function setSearchOnlySexChat(state, value) {
    const tmpContent = _.cloneDeep(state.extraContent);

    if (!!value) {
        tmpContent.sexChat = true;
    } else {
        delete tmpContent.sexChat;
    }

    state.extraContent = tmpContent;
}

function setAsia(state, value) {
    state.asia = value;
}

function setSuggestedRedirectRegion(state, value) {
    state.suggestedRedirectRegion = value;
}

function setMainAccountComponentWasLoadedBefore(state, value) {
    state.mainAccountComponentWasLoadedBefore = value;
}

function setProfileBlurredModalForceShow(state, value) {
    state.profileBlurredModalForceShow = value;
}

function setPageChanges(state, pageChanges) {
    state.pageChanges = pageChanges;
}

function setCountryName(state, value){
    state.countryName = value;
}
function setCountryNameShort(state, value){
    state.countryNameShort = value;
}
function setCountrySlug(state, value){
    state.countrySlug = value;
}

function setWebsocketIsReady(state, value){
    state.websocketIsReady = value;
}

/**
 * @typedef {Object} TipProfileModalRedirector
 * @property {string} tipUsername
 * @property {number} tipAmount
 * @property {string} tipRedirectProfilePath
 */

/**
 * @param state
 * @param tipProfileModalRedirector {TipProfileModalRedirector}
 */
function setTipProfileModalRedirector(state, tipProfileModalRedirector){
    state.tipProfileModalRedirector = tipProfileModalRedirector;
}

function setCdnProductionUrl(state, cdnProductionUrl){
    state.cdnProductionUrl = cdnProductionUrl;
}

function setUserIsFromExplicitRegion(state, userIsFromExplicitRegion){
    state.userIsFromExplicitRegion = userIsFromExplicitRegion;
}

function setHideExplicitRegionAds(state, hideExplicitRegionAds){
    state.hideExplicitRegionAds = hideExplicitRegionAds;
}

function setShowStoriesCookieSet(state, showStoriesCookieSet){
    state.showStoriesCookieSet = showStoriesCookieSet;
}

export default {
    setAppReady,
    setRejection,
    setCurrentUser,
    setSettings,
    removeCurrentUser,
    updateCurrentUser,
    setPreFetchedUser,
    setCmsContent,
    setLocation,
    setPrice,
    setServices,
    setFeatures,
    setCategory,
    setExtraContent,
    setSearchResponse,
    refreshSearch,
    setSearchStories,
    setFilterOpened,
    setCategoryTemp,
    setExtraContentTemp,
    setServicesTemp,
    setPriceTemp,
    setFeaturesTemp,
    setSearchDoneFromHome,
    setAllServices,
    setLocationTemp,
    setSearchScrollPosition,
    setTopServices,
    setSearchRadius,
    setSearchRadiusTemp,
    setSimilarEscorts,
    setSeoView,
    setIs404View,
    setTranslate,
    setRegionData,
    setLocale,
    setHomeGirls,
    setLoading,
    setSexySantaBannerIsVisible,
    setIsManagerLoggedInAsEscort,
    setManagerAsEscortData,
    setIsSeekingServicesProfile,
    setShouldReloadConversations,
    setConversationUnreadMessageCount,
    setSelectedConversation,
    setUserProfileViewsNotificationCount,
    setFeatureOptions,
    setRanges,
    setSavedSearchNewEscorts,
    setVenue,
    setAsia,
    setSearchOnlyWithPrivateGallery,
    setSearchOnlySexChat,
    setSuggestedRedirectRegion,
    setMainAccountComponentWasLoadedBefore,
    setProfileBlurredModalForceShow,
    setPageChanges,
    setCountryName,
    setCountryNameShort,
    setCountrySlug,
    setCdnProductionUrl,
    setTipProfileModalRedirector,
    setWebsocketIsReady,
    setUserIsFromExplicitRegion,
    setHideExplicitRegionAds,
    setShowStoriesCookieSet,
}
